import useAxios from 'axios-hooks';
import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../routes/RouterPaths';
import { MainCardContainer } from '../../styled/containers/MainCardContainer';
import { H2 } from '../../styled/miscellaneous/hx';
import { Table, Th, Tr } from '../../styled/table/table';
import { IExchangeInfo } from '../../types/axios/Exchanges';
import { AUTH_ERROR, isAxiosError } from '../../utils/axiosUtils';
import CentredLoader from '../miscellaneous/CenteredLoader';
import ErrorBox from '../miscellaneous/ErrorBox';
import { useAuth } from '../../hooks/useAuth';
import ExchangeRow from './ExchangeRow';

const REFETCH_AFTER = 60 * 1000;

const Exchanges: FC = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [{ data, error }, fetchExchanges] = useAxios<IExchangeInfo[]>({
    url: '/exchanges/getAll',
    method: 'GET',
    headers: { authorization: token },
  });

  useEffect(() => {
    const interval = window.setInterval(() => fetchExchanges(), REFETCH_AFTER);
    return () => {
      window.clearInterval(interval);
    };
  }, [fetchExchanges]);

  useEffect(() => {
    if (error && isAxiosError(error, AUTH_ERROR)) {
      navigate(RouterPaths.LOG_OUT);
    }
  }, [error, navigate]);

  return (
    <MainCardContainer>
      <div>
        <H2>Exchanges</H2>
        {!data ? (
          <CentredLoader />
        ) : error ? (
          <ErrorBox />
        ) : (
          <Table>
            <tbody>
              <Tr>
                <Th>Exchange name</Th>
                <Th>Tickers</Th>
                <Th>Sockets</Th>
                <Th>Rest API</Th>
                <Th>Rest Penalty</Th>
                <Th>Arbitrage</Th>
              </Tr>
              {data.map(exchange => (
                <ExchangeRow key={exchange.exchangeName} data={exchange} />
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </MainCardContainer>
  );
};

export default Exchanges;
